import ApiService from "@/services/api.service";

export default {
    namespaced: true,
    state: {
        listMailReali: {},
        loading: false,
        testingConnection: false,
        globalLoading: false,
        error: {},
        emailProviders: [],
        loadingProviders: false,
    },
    getters: {
        getListMailReali: (state) => state.listMailReali,
        getLoading: (state) => state.loading,
        testingConnection: (state) => state.testingConnection,
        error: (state) => state.error,
        emailProviders: (state) => state.emailProviders,
        loadingProviders: (state) => state.loadingProviders,
    },
    mutations: {
        SET_MAIL_REALI_LIST(state, listMailReali) {
            state.listMailReali = listMailReali;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_LOADING_TEST(state, val) {
            state.testingConnection = val;
        },
        SET_GLOBAL_LOADING(state, val) {
            state.globalLoading = val;
        },
        SET_ERROR(state, val) {
            state.error = val;
        },
        SET_EMAIL_PROVIDERS(state, providers) {
            state.emailProviders = providers;
        },
        SET_LOADING_PROVIDERS(state, val) {
            state.loadingProviders = val;
        },
    },
    actions: {
        FETCH_LIST_MAIL_REALI({ commit }, query) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(`MailReali?${query}`)
                    .then((res) => {
                        commit("SET_MAIL_REALI_LIST", res.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },

        CREATE_MAIL({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);

            return new Promise((resolve, reject) => {
                ApiService.post(`MailReali`, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        GET_MAIL({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.download(`MailReali`, id)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },
        UPDATE_MAIL({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);

            return new Promise((resolve, reject) => {
                ApiService.update(`MailReali`, params.id, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        TEST_CONNECTION({ commit }, params) {
            commit("SET_LOADING_TEST", true);

            return new Promise((resolve, reject) => {
                ApiService.post(`MailReali/TestConnection`, params)
                    .then((res) => {
                        commit("SET_LOADING_TEST", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_LOADING_TEST", false);
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        reject(response);
                    });
            });
        },
        FETCH_EMAIL_PROVIDERS({ commit }) {
            commit("SET_LOADING_PROVIDERS", true);

            return new Promise((resolve, reject) => {
                ApiService.get(`EmailProvider`)
                    .then((res) => {
                        commit("SET_EMAIL_PROVIDERS", res.data);
                        commit("SET_LOADING_PROVIDERS", false);
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_LOADING_PROVIDERS", false);
                        reject(response);
                    });
            });
        },
        GET_PROVIDER_CONFIG({ commit }, providerName) {
            return new Promise((resolve, reject) => {
                ApiService.get(`EmailProvider/${providerName}`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        reject(response);
                    });
            });
        },
    },
};
